import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Formik } from 'formik'
import Modal from '../../modal/modal.component'
import Button from '../../buttons/buttons.component'
import StyledChangeAddressModalBody from './styles/styled-change-address-modal-body.style'
import { addressFieldsSchema } from '../address-fields/address-fields.schema'
import { AddressFields } from '../address-fields/address-fields.component'
import { AddressFieldsHelper } from '../address-fields/address-fields.helper'
import { toastActions, addressesActions } from '../../../actions'

const initialValues = {
	zipCode: '',
	street: '',
	number: '',
	complement: '',
	neighborhood: '',
	city: '',
	state: ''
}

class NewAddressModal extends Component {
	setFormData = form => data => AddressFieldsHelper.setFormData(form, data)

	resetForm = form => () =>
		AddressFieldsHelper.setFormData(form, initialValues)

	addAddress = async addressValues => {
		const { addresses } = this.props

		const isDuplicatedAddress = AddressFieldsHelper.isAddressDuplicated(
			addressValues,
			addresses
		)

		if (isDuplicatedAddress) {
			const { danger } = this.props

			danger({ message: 'O endereço já existe' })
			return
		}

		const {
			closeNewAddressModal,
			editingAddress,
			addOrUpdateAddress,
			addressesOwnerId
		} = this.props

		addressValues.billingAddress = true

		if (editingAddress) {
			const oldAddress = addresses.filter(
				address => address.id === editingAddress
			)[0]

			addressValues = Object.assign(oldAddress, addressValues)
		}

		addOrUpdateAddress(addressesOwnerId, addressValues)
		closeNewAddressModal()
	}

	render() {
		const {
			isOpen,
			editingAddress,
			addresses,
			closeNewAddressModal
		} = this.props

		return (
			<Modal
				ref="newAddressModal"
				onClose={() => closeNewAddressModal()}
				isOpen={isOpen}
				medium>
				<StyledChangeAddressModalBody>
					<div className="orange semi-bold f30">Adicionar endereço</div>
					<Formik
						initialValues={
							editingAddress
								? addresses.filter(
										address => address.id === editingAddress
								  )[0]
								: initialValues
						}
						validationSchema={addressFieldsSchema}
						ref="form"
						onSubmit={this.addAddress}
						render={props => (
							<form
								noValidate
								onSubmit={props.handleSubmit}
								style={{ width: '100%' }}>
								<AddressFields
									{...props}
									setFormData={this.setFormData(this.refs.form)}
									resetForm={this.resetForm(this.refs.form)}
									enabled={!!editingAddress}
								/>
								<div
									style={{
										display: 'flex',
										justifyContent: 'flex-end',
										margin: '4rem auto 25px'
									}}>
									<Button
										danger
										type="button"
										onClick={() => this.refs.newAddressModal.close()}>
										Cancelar
									</Button>
									<Button
										primary
										type="submit"
										style={{ marginLeft: '15px' }}>
										Salvar
									</Button>
								</div>
							</form>
						)}
					/>
				</StyledChangeAddressModalBody>
			</Modal>
		)
	}
}

const mapStatetoProps = ({ addresses }) => ({
	...addresses
})

const mapDispatchToPros = dispatch =>
	bindActionCreators(
		{
			danger: toastActions.danger,
			warning: toastActions.warning,
			closeNewAddressModal: addressesActions.closeNewAddressModal,
			addOrUpdateAddress: addressesActions.addOrUpdateAddress
		},
		dispatch
	)

const connectedNewAddressModal = connect(
	mapStatetoProps,
	mapDispatchToPros
)(NewAddressModal)

export { connectedNewAddressModal as NewAddressModal }
